import React from 'react';
import {
  Image,
  ImageField,
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { useTheme, styled } from '@mui/material/styles';

export type ResponsiveImageProps = WithSitecoreContextProps & {
  responsiveFields: {
    MobileImageSrc: ImageField;
    DesktopImageSrc: ImageField;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

export const ResponsiveImage = ({
  responsiveFields,
  sitecoreContext,
}: ResponsiveImageProps): React.JSX.Element => {
  const theme = useTheme();
  const ResponsiveImageStyle = styled('div')(({ theme }) => ({
    color: '#17457a !important',
  }));

  if (responsiveFields) {
    return (
      <ResponsiveImageStyle>
        {sitecoreContext.pageEditing && <p>Responsive Image Component Edit Mode</p>}
        <picture>
          <source media="(max-width: 600px)" srcSet={responsiveFields.MobileImageSrc?.value?.src} />
          {/* <source media="(max-width: 960px)" srcSet={responsiveFields.TabletImageSrc?.value?.src} /> */}
          <source srcSet={responsiveFields.DesktopImageSrc?.value?.src} />
          <Image className="img-responsive" field={responsiveFields.DesktopImageSrc?.value} />
        </picture>
      </ResponsiveImageStyle>
    );
  } else if (!responsiveFields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }
  return <></>;
};

export default withSitecoreContext()(ResponsiveImage);
